export default __webpack_public_path__ + "3dbc498410b93155e54daf1d48e0c54c.woff2";